export default "__VITE_ASSET__627a41c7__"